import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Line } from "react-chartjs-2";
import Box from "@mui/material/Box";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { collection, query, onSnapshot, where } from "firebase/firestore";
import { db } from "../firebase_conf";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(0),
  color: theme.palette.text.secondary,
  borderRadius: 0,
}));

const Home = () => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );
  function findOcc(arr, key) {
    let arr2 = [];

    arr.forEach((x) => {
      if (
        arr2.some((val) => {
          return val[key] === x[key];
        })
      ) {
        arr2.forEach((k) => {
          if (k[key] === x[key]) {
            k["incident"]++;
          }
        });
      } else {
        let a = {};
        a[key] = x[key];
        a["incident"] = 1;
        arr2.push(a);
      }
    });

    return arr2;
  }
  const [incidentData, setIncidentData] = useState({});

  useEffect(() => {
    const q = query(
      collection(db, "reported_incident"),
      where("isReceived", "==", true)
    );
    onSnapshot(q, (snapshot) => {
      const docs = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      const _docs = docs.map((data) => {
        return {
          ...data,
          date: new Date(data.timestamp.seconds * 1000).toLocaleDateString(),
        };
      });

      const _data = {
        labels: findOcc(_docs, "date").map((data) => data.date),
        datasets: [
          {
            label: "Reported Incident",
            data: findOcc(_docs, "date").map((data) => data.incident),

            borderWidth: 2,
            fill: true,
            tension: 0.1,
            borderColor: "rgb(75, 192, 192)",
            beginAtZero: true,
          },
        ],
      };
      setIncidentData(_data);
    });
  }, []);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Incident Report Chart",
      },
    },
  };

  return (
    <Container maxWidth="lg">
      <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 4 }}>
        <Link underline="hover" color="inherit" href="/">
          Home
        </Link>
        <Typography color="text.primary">Dashboard</Typography>
      </Breadcrumbs>
      <Box sx={{mt:2}}>
        <Grid container spacing={0}>
          <Item
            sx={{
              height: "auto",
              display: "grid",
              placeItems: "center",
              padding: 4,
              background: "white",
              width: "100%",
            }}
          >
            {incidentData.datasets ? (
              <Line data={incidentData} options={options} />
            ) : null}
          </Item>
        </Grid>
      </Box>
    </Container>
  );
};

export default Home;
